import { getCollaboratorsCard } from '../../api/Public/collaborators';

export default async function getSample(index) {
    const result = await getCollaboratorsCard({ category: index });

    if (!result.success)
        return null;

    const traders = result.data;
    if (traders && traders.length > 0) {
        const shuffled = [...traders].sort(() => Math.random() - 0.5);
        const sample = shuffled.slice(0, 4);
        return sample;
    }
    return null;
}